import React from 'react'
import { Brand, DevTools, Position, State } from 'src/types'
import DevTool from 'src/features/development'
import { dxmCanvasGloveBack } from 'src/features/brands/dxm/canvas/rightThrow/glove/back/useDxmCanvasGloveBack'
import { ysrCanvasGloveBack } from 'src/features/brands/yellStory/canvas/glove/back/useYsrCanvasGloveBack'
import { ragdelionCanvasGloveBack } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/useRagdelionCanvasGloveBack'
import { gorillaCanvasGloveBack } from 'src/features/brands/gorilla/canvas/glove/rightThrow/back/useGorillaCanvasGloveBack'
import { atomsCanvasGloveBack, atomsUsModelCanvasGloveBack } from 'src/features/brands/atoms/canvas/rightThrow/glove/back/useAtomsCanvasGloveBack'
import { atomsCanvasCatcherMittBack } from 'src/features/brands/atoms/canvas/rightThrow/catchermitt/back/useAtomsCanvasCatcherMittBack'
import { atomsCanvasFirstMittBack } from 'src/features/brands/atoms/canvas/rightThrow/firstmitt/back/useAtomsCanvasFirstMittBack'
import { ragdelionCanvasCatcherMittBack } from 'src/features/brands/ragdelion/canvas/catchermitt/rightThrow/back/useRagdelionCanvasCatcherMittBack'
import { ragdelionCanvasFirstMittBack } from 'src/features/brands/ragdelion/canvas/firstmitt/rightThrow/back/useRagdelionCanvasFirstMittBack'
import { gorillaCanvasCatcherMittBack } from 'src/features/brands/gorilla/canvas/catchermitt/rightThrow/back/useGorillaCanvasCatcherMittBack'
import { gorillaCanvasFirstMittBack } from 'src/features/brands/gorilla/canvas/firstmitt/rightThrow/back/useGorillaCanvasFirstMittBack'
import { atomsCanvasGloveBackLeftThrow } from 'src/features/brands/atoms/canvas/leftThrow/glove/back/useAtomsCanvasGloveBack'
import { atomsCanvasFirstMittBackLeftThrow } from 'src/features/brands/atoms/canvas/leftThrow/firstmitt/back/useAtomsCanvasFirstMittBack'
import { atomsCanvasCatcherMittBackLeftThrow } from 'src/features/brands/atoms/canvas/leftThrow/catchermitt/back/useAtomsCanvasCatcherMittBack'
import { dxmCanvasGloveBackLeftThrow } from 'src/features/brands/dxm/canvas/leftThrow/glove/back/useDxmCanvasGloveBack'
import { gorillaCanvasGloveBackLeftThrow } from 'src/features/brands/gorilla/canvas/glove/leftThrow/back/useGorillaCanvasGloveBack'
import { gorillaCanvasFirstMittBackLeftThrow } from 'src/features/brands/gorilla/canvas/firstmitt/leftThrow/back/useGorillaCanvasFirstMittBack'
import { ragdelionCanvasGloveBackLeftThrow } from 'src/features/brands/ragdelion/canvas/glove/leftThrow/back/useRagdelionCanvasGloveBack'
import { ragdelionCanvasFirstMittBackLeftThrow } from 'src/features/brands/ragdelion/canvas/firstmitt/leftThrow/back/useRagdelionCanvasFirstMittBack'
import { ragdelionCanvasCatcherMittBackLeftThrow } from 'src/features/brands/ragdelion/canvas/catchermitt/leftThrow/back/useRagdelionCanvasCatcherMittBack'
import { usModelOfAtomsChecker } from '../../atoms/helper'
import { dxmCanvasCatcherMittBack } from '../../dxm/canvas/rightThrow/catcher/back/useDxMCanvasCatcherMittBack'
import { dxmCanvasCatcherMittBackLeftThrow } from '../../dxm/canvas/leftThrow/catcher/back/dxmCanvasCatcherMittBack'
import { dxmCanvasFirstMittBack } from '../../dxm/canvas/rightThrow/firstmitt/back/useDxmCanvasFirstMittBack'
import { dxmCanvasFirstMittBackLeftThrow } from '../../dxm/canvas/leftThrow/firstmitt/back/useDxmCanvasFirstMittBack'
// import { treasureCanvasGloveBack } from 'src/features/brands/treasure/canvas/glove/back/useTreasureCanvasGloveBack'
// import { treasureCanvasCatcherMittBack } from 'src/features/brands/treasure/canvas/catchermitt/back/useTreasureCanvasCatcherMittBack'
// import { treasureCanvasFirstMittBack } from 'src/features/brands/treasure/canvas/firstmitt/back/useTreasureCanvasFirstMittBack'

type Props = {
  state: State
  brand: Brand
  position: Position
  devFlg?: boolean
  domId?: string
  devTools?: DevTools
  devToolStyle?: {
    backgroundImage?: string
    backgroundRepeat?: string
    backgroundPosition?: string
    backgroundSize?: string
    maxWidth?: string
  }
  handleCoordinate?: (e: React.MouseEvent<HTMLCanvasElement, MouseEvent>) => void
}

export const FigureBack: React.FC<Props> = ({
  state,
  position: beforeCheckPosition,
  brand,
  devFlg,
  domId,
  devTools,
  devToolStyle,
  handleCoordinate
}) => {
  const position: Position = Array.isArray(beforeCheckPosition) ? beforeCheckPosition[0] : beforeCheckPosition // 2024/08/01くらいになったら削除
  const dominantArmValue = state.dominantArm.value
  const productNumber = state.baseModel?.productNumber
  React.useEffect(() => {
    const canvas = document.getElementById(domId || 'canvasBack') as HTMLCanvasElement
    const ctx = canvas.getContext('2d') as CanvasRenderingContext2D
    ctx.strokeStyle = '#282828'
    ctx.lineWidth = 2
    const canvasWidth = canvas.width
    const isNotSelectedBaseModel = productNumber === ''
    if (isNotSelectedBaseModel) return
    if (usModelOfAtomsChecker(productNumber)) {
      atomsUsModelCanvasGloveBack(ctx, state, position)
      return
    }
    switch (position) {
      case 'catcher':
        switch (brand) {
          case 'atoms':
            switch (state.dominantArm.value) {
              case 'leftThrow': // 左投げ
                atomsCanvasCatcherMittBackLeftThrow(ctx, state, canvasWidth)
                break
              default:
                // 右投げ or 未選択
                atomsCanvasCatcherMittBack(ctx, state)
                break
            }
            break
          case 'ragdelion':
            switch (state.dominantArm.value) {
              case 'leftThrow':
                ragdelionCanvasCatcherMittBackLeftThrow(ctx, state, canvasWidth)
                break
              default:
                ragdelionCanvasCatcherMittBack(ctx, state)
                break
            }
            break
          // case 'treasure':
          //   treasureCanvasCatcherMittBack(ctx, state)
          //   break
          case 'gorilla':
            gorillaCanvasCatcherMittBack(ctx, state)
            break
          case 'dxm':
            switch (state.dominantArm.value) {
              case 'leftThrow': // 左投げ
                dxmCanvasCatcherMittBackLeftThrow(ctx, state, canvasWidth)
                break
              default:
                // 右投げ or 未選択
                dxmCanvasCatcherMittBack(ctx, state)
                break
            }
            break
        }
        break
      case 'first':
        switch (brand) {
          case 'atoms':
            switch (dominantArmValue) {
              case 'leftThrow': // 左投げ
                atomsCanvasFirstMittBackLeftThrow(ctx, state, canvasWidth)
                break
              default:
                // 右投げ or 未選択
                atomsCanvasFirstMittBack(ctx, state)
                break
            }
            break
          case 'dxm':
            switch (dominantArmValue) {
              case 'leftThrow': // 左投げ
                dxmCanvasFirstMittBackLeftThrow(ctx, state, canvasWidth)
                break
              default:
                // 右投げ or 未選択
                dxmCanvasFirstMittBack(ctx, state)
                break
            }
            break
          case 'ragdelion':
            switch (dominantArmValue) {
              case 'leftThrow':
                ragdelionCanvasFirstMittBackLeftThrow(ctx, state, canvasWidth)
                break
              default:
                ragdelionCanvasFirstMittBack(ctx, state)
                break
            }
            break
          // case 'treasure':
          //   treasureCanvasFirstMittBack(ctx, state)
          //   break
          case 'gorilla':
            switch (dominantArmValue) {
              case 'leftThrow': // 左投げ
                gorillaCanvasFirstMittBackLeftThrow(ctx, state, canvasWidth)
                break
              default:
                // 右投げ or 未選択
                gorillaCanvasFirstMittBack(ctx, state)
                break
            }
            break
        }
        break
      default:
        switch (brand) {
          case 'atoms':
            switch (dominantArmValue) {
              case 'leftThrow':
                atomsCanvasGloveBackLeftThrow(ctx, state, position, canvasWidth)
                break
              default:
                atomsCanvasGloveBack(ctx, state, position)
                break
            }
            break
          case 'yellStory':
            ysrCanvasGloveBack(ctx, state)
            break
          case 'dxm':
            switch (dominantArmValue) {
              case 'leftThrow': // 左投げ
                dxmCanvasGloveBackLeftThrow(ctx, state, position, canvasWidth)
                break
              default:
                // 右投げ or 未選択
                dxmCanvasGloveBack(ctx, state, position)
                break
            }
            break
          case 'ragdelion':
            switch (dominantArmValue) {
              case 'leftThrow': // 左投げ
                ragdelionCanvasGloveBackLeftThrow(ctx, state, position, canvasWidth)
                break
              default:
                // 右投げ or 未選択
                ragdelionCanvasGloveBack(ctx, state, position)
                break
            }
            break
          case 'gorilla':
            switch (dominantArmValue) {
              case 'leftThrow': // 左投げ
                gorillaCanvasGloveBackLeftThrow(ctx, state, position, canvasWidth)
                break
              default:
                // 右投げ or 未選択
                gorillaCanvasGloveBack(ctx, state, position)
                break
            }
            break
          // case 'treasure':
          //   treasureCanvasGloveBack(ctx, state, position)
          //   break
        }
        break
    }
  }, [state])
  return (
    <>
      {devFlg && handleCoordinate ? (
        <>
          <canvas
            width={880}
            height={position === 'catcher' || position === 'first' ? 680 : 630}
            id={domId || 'canvasBack'}
            style={{ maxWidth: '100%', ...devToolStyle }}
            onClick={(e) => handleCoordinate(e)}
          />
          <DevTool devTools={devTools} />
        </>
      ) : (
        <canvas
          width={880}
          height={position === 'catcher' || position === 'first' ? 680 : 630}
          id={domId || 'canvasBack'}
          style={{ maxWidth: '100%' }}
        />
      )}
    </>
  )
}
